/**
 * Centralized GSAP configuration and plugin registration
 * Import GSAP and plugins from this file to ensure consistent setup
 * and avoid duplicate plugin registrations across the application.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

// Register all plugins once, centrally
gsap.registerPlugin(ScrollTrigger, SplitText);

// Configure global GSAP defaults for consistent performance
gsap.defaults({
    duration: 1,
    ease: "power3.out"
});

// Export configured GSAP and plugins
export { gsap, ScrollTrigger, SplitText };

// Export default instance for convenience
export default gsap;